import { UserType } from "../types"

export const showFullName = ( userInfo: UserType  = {}) => {
  if (userInfo.lastName && userInfo.firstName) {
    return `${userInfo.lastName +  ' ' +userInfo.firstName}`
  }

  return  userInfo.lastName ?? userInfo.firstName ?? 'No Name'
}